import NationalHeartFoundationAustralia from "./NationalHeartFoundationAustralia";

export default {
    NationalHeartFoundationAustralia
};
